import { Component, inject, input, OnInit } from '@angular/core'
import { SwitchComponent } from '@ftr/forms'
import { CookieStorageService } from '@ftr/foundation'
import { take } from 'rxjs'
import { LaunchDarklyModule } from '../launch-darkly.module'
import { LaunchDarklyService, LD_PERSISTENT_ATTRIBUTE_STORAGE_KEY } from '../services/launch-darkly.service'

@Component({
  selector: 'ftr-persistent-flag-switch',
  templateUrl: './persistent-flag-switch.component.html',
  styleUrl: './persistent-flag-switch.component.css',
  imports: [SwitchComponent, LaunchDarklyModule],
})
export class PersistentFlagSwitchComponent implements OnInit {
  private readonly launchDarklyService = inject(LaunchDarklyService)
  private readonly cookieStorage = inject(CookieStorageService)

  persistentFlagEnabled = false
  showSwitch = false
  text = input<string>('Set persistent attribute to LD')

  ngOnInit(): void {
    this.persistentFlagEnabled = this.cookieStorage.getGlobal<string>(LD_PERSISTENT_ATTRIBUTE_STORAGE_KEY) === 'true'

    this.launchDarklyService
      .observeFlagChanges<boolean>('persistent-flag-switch')
      .pipe(take(1))
      .subscribe(isEnabled => {
        this.showSwitch = isEnabled

        if (!isEnabled && this.cookieStorage.getGlobal<string>(LD_PERSISTENT_ATTRIBUTE_STORAGE_KEY)) {
          this.cookieStorage.removeGlobal(LD_PERSISTENT_ATTRIBUTE_STORAGE_KEY)
          this.persistentFlagEnabled = false
        }
      })
  }

  onPersistentFlagChange(enabled: boolean): void {
    this.persistentFlagEnabled = enabled
    if (enabled) {
      this.cookieStorage.setGlobal(LD_PERSISTENT_ATTRIBUTE_STORAGE_KEY, 'true')
    } else {
      this.cookieStorage.removeGlobal(LD_PERSISTENT_ATTRIBUTE_STORAGE_KEY)
    }
  }
}
